module.exports = __webpack_public_path__ + "static/media/G1-18-União-das-Arqueiras-cod38.06e1fd8a.png";